module.exports = __webpack_public_path__ + "img/MasterCard.348bae60.svg";